export const getArrayOf = (length: number = 5): Array<number> =>
  Array.from({length}, (_v, i) => i)

const noopCompact = <T, U>(value: T): U | undefined | null => {
  // @ts-ignore
  return value as U
}
export const compactMap = <T, U>(
  original: Array<T>,
  fn: (value: T) => U | undefined | null = noopCompact,
): Array<U> => {
  const newArray: Array<U> = []
  for (const t of original) {
    const newValue = fn(t)
    if (newValue) newArray.push(newValue)
  }
  return newArray
}

export const firstOf = <T>(
  original: Array<T> | undefined,
  predicate?: (value: T) => boolean,
): T | undefined => {
  if (original === undefined) return undefined
  if (original.length === 0) return undefined
  if (predicate) {
    for (let i = original.length - 1; i >= 0; i--) {
      if (predicate(original[i])) return original[i]
    }
  }
  return original[0]
}

export const lastOf = <T>(array: Array<T> | undefined): T | undefined => {
  if (array === undefined || !array.length) return undefined
  return array[Math.max(0, array.length - 1)]
}

export const addToSet = <T>(set: Set<T>, value: T | undefined): boolean => {
  if (!value) return false
  if (set.has(value)) return false
  set.add(value)
  return true
}
